<template>
  <div class="row no-wrap items-start q-ml-md" v-if="value" @click.stop>
    <span class="q-mr-sm" style="line-height: 40px">时间:</span>
    <q-input
      dense
      filled
      :value="(value || {}).time"
      mask="time"
      :rules="['time']"
      style="width: 120px"
      no-error-icon
      @input="(v) => hanldeTimeChange(v)"
      label="时间"
    >
      <template v-slot:append>
        <q-icon name="fas fa-clock" class="cursor-pointer">
          <q-popup-proxy class="q-pa-none" :breakpoint="800">
            <q-time
              :value="(value || {}).time"
              @input="(v) => hanldeTimeChange(v)"
            >
              <div class="row items-center justify-end">
                <q-btn v-close-popup label="Close" color="primary" flat />
              </div>
            </q-time>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>

    <span class="q-mr-sm q-ml-md" style="line-height: 40px">数量:</span>
    <q-input
      :min="0"
      dense
      filled
      type="number"
      label="请输入数量"
      :value="(value || {}).number"
      @input="handleNumberChange"
    />
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";
import { fillZero } from "@/utils/fillZero";
export default {
  mixins: [QuestionChoiceMixin],

  data() {
    return {};
  },

  watch: {},

  computed: {},

  beforeMount() {
    if (!this.value) {
      this.$emit("change", {});
    }
    if (this.value && !this.value.time) {
      const now = new Date();
      this.$emit("change", {
        ...(this.value || {}),
        time: `${fillZero(now.getHours(), 2)}:${fillZero(now.getMinutes(), 2)}`,
      });
    }
  },

  methods: {
    hanldeTimeChange(newTime) {
      this.$emit("change", {
        ...(this.value || {}),
        time: newTime,
      });
    },

    handleNumberChange(num) {
      this.$emit("change", {
        ...(this.value || {}),
        number: num,
      });
    },
  },
};
</script>

<style lang="scss">
.q-menu {
  padding: 0;
}
</style>
